module.exports = __webpack_public_path__ + "media/images/eng2-0db56baf246130f00a875193088a7067.png";